import React, { FC } from 'react';
import { Text } from '@carnica/ui-kit';
import classNames from 'classnames/bind';
import { IconRefresh } from '@carnica/graphics';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

type ErrorDataProps = {
  onClick: () => void;
  text: string;
};

export const ErrorData: FC<ErrorDataProps> = ({ text, onClick }) => (
  <div className={cn('error')}>
    <Text className={cn('name')} color="secondary" size="xs">
      {text}
    </Text>
    <IconRefresh className={cn('refresh')} color="secondary" onClick={onClick} />
  </div>
);
